module.exports = __webpack_public_path__ + "img/Tele-Background-D.bb085ad1.png";